import {createAction, props} from '@ngrx/store';
import {NewsDTO, PageableDTO} from '../../../../openapi/agrarinformationen-openapi';
import {MappedHttpErrorResponse} from '@adnova/jf-ng-components';


export class NewsArticleActions {

  private static readonly prefix = '[News Article] ';

  public static readLatestNews = createAction(
    this.prefix + 'Read latest News.',
    props<{ pageableDto?: PageableDTO }>(),
  );

  public static readLatestNewsSuccess = createAction(
    this.prefix + 'Set news ids that should be displayed at news component.',
    props<{ newsDtos: NewsDTO[], totalElements: number }>(),
  );

  public static readLatestNewsFailure = createAction(
    this.prefix + 'Failed to read news.',
    props<{ error: MappedHttpErrorResponse }>(),
  );

  public static changeLatestNewsPageable = createAction(
    this.prefix + 'Changed pageable.',
    props<{ latestNewsPageable: PageableDTO }>(),
  );

  public static updateCurrentNewsId = createAction(
    this.prefix + 'Update the id of the currently visited news article.',
    props<{currentNewsId: number}>()
  );

}
